import { render, staticRenderFns } from "./azButton.vue?vue&type=template&id=93681be8&scoped=true&"
import script from "./azButton.vue?vue&type=script&lang=js&"
export * from "./azButton.vue?vue&type=script&lang=js&"
import style0 from "./azButton.vue?vue&type=style&index=0&id=93681be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93681be8",
  null
  
)

export default component.exports